'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _executivesummaryPoc = require('./executivesummary.poc.html');

var _executivesummaryPoc2 = _interopRequireDefault(_executivesummaryPoc);

var _executivesummaryPoc3 = require('./executivesummary.poc.controller');

var _executivesummaryPoc4 = _interopRequireDefault(_executivesummaryPoc3);

require('./executivesummary.poc.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var executivesummaryPOCComponent = {
  restrict: 'E',
  bindings: {},
  template: _executivesummaryPoc2.default,
  controller: _executivesummaryPoc4.default,
  controllerAs: 'vm'
};

exports.default = executivesummaryPOCComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary_poc/executivesummary.poc.component.js